module.exports = __webpack_public_path__ + "media/images/lp_voice-1-a9fe2b1875a63fe8992cdd8eec85fb51.webp";